import { createContext } from 'react';

type UpdateNodesContextType = {
  updateNodes: string[];
  setUpdateNodes: (updateNodes: string[]) => void;
};

export const UpdateNodesContext = createContext<UpdateNodesContextType>({
  updateNodes: [],
  setUpdateNodes: () => {}
});
